export interface IInitPayment {
  marketDomain: string;
  appId: string;
  merchantId: number;
  appName?: string;
  successUrl?: string;
}

const initPayment = (params: IInitPayment) => {
  const { marketDomain, appId, merchantId, appName, successUrl } = params;
  let queryString = `appId=${appId}&merchantId=${merchantId}`;
  appName && (queryString += `&appName=${appName}`);
  successUrl && (queryString += `&successUrl=${successUrl}`);
  const target = `${marketDomain}/license-plan?${queryString}`;
  window.location.href = target;
};

export const licensePlan = {
  initPayment,
};
